module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/page-two-a.d2bdb7cf.png";